<template>
	<div>
		<div class="pb-2" v-if="salesProduct.length == 0">
			<not-found-cyan></not-found-cyan>
		</div>
		<div class="pr-2 mt-n2" v-else>
			<apexchart type="bar" height="310" :options="chartOptions" :series="salesProduct"></apexchart>
		</div>
	</div>
</template>

<script>
import { mapActions,  mapState } from 'vuex'
import apexchart from 'vue-apexcharts'

export default {
	components: {
		apexchart,
	},
	data() {
		return {
			series: [{
				name: 'KMU',
				data: [44, 55, 57, 56, 61, 58, 63, 60, 66, 20, 50, 58]
			}, {
				name: 'KPM',
				data: [76, 85, 101, 98, 87, 105, 91, 114, 94, 83, 76, 25]
			}],
			chartOptions: {
				chart: {
					type: 'bar',
					toolbar: {
						show: false,
					}
				},
				colors: ['#0097A7', '#80DEEA', '#006064', '#B2EBF2'],
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: '55%',
						endingShape: 'rounded'
					},
				},
				legend: {
					horizontalAlign: 'left',
				},
				dataLabels: {
					enabled: false
				},
				stroke: {
					show: true,
					width: 2,
					colors: ['transparent']
				},
				xaxis: {
					categories: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Oct', 'Nov', 'Des'],
				},
				yaxis: {
				},
				fill: {
					opacity: 1,
				},
				tooltip: {
					y: {
						formatter: function (val) {
							return val + " terjual"
						}
					}
				}
			},
		}
	},
	computed: {
		...mapState('dashboardSupplier', ['listSalesProduct']),

		salesProduct() {
			let data = Object.keys(this.listSalesProduct).map((val) => this.listSalesProduct[val])
			data.forEach(function(val) {
				val.name = val.product_code
				val.data = val.quantity
				delete val.product_code
				delete val.quantity
			})
			return data
		}
	},
	methods: {
		...mapActions('dashboardSupplier', ['getSalesProduct']),
	},
	created() {
		this.getSalesProduct()
	}
}
</script>